import { useTranslation } from 'react-i18next';
import Button from '@/components/ui/Button';
import styles from './SharedStyles.module.css';

interface ParseError {
  rowNumber: number;
  message: string;
}

interface ConfirmDialogProps {
  fundName: string;
  fundId: number;
  rowCount: number;
  parseErrors: ParseError[];
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
  featureLabel: string;
}

export default function ConfirmDialog({
  fundName,
  fundId,
  rowCount,
  parseErrors,
  onConfirm,
  onCancel,
  isLoading,
  featureLabel,
}: ConfirmDialogProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.confirmContainer}>
      <h3 className="heading-h3-semibold">{t('bulkUploads.confirmTitle')}</h3>

      <div className={styles.confirmDetails}>
        <p className="body-md-regular">
          <strong>{t('bulkUploads.fund')}:</strong> {fundName} (#{fundId})
        </p>
        <p className="body-md-regular">
          <strong>{t('bulkUploads.action')}:</strong> {featureLabel}
        </p>
        <p className="body-md-regular">
          <strong>{t('bulkUploads.rowsToProcess')}:</strong> {rowCount}
        </p>
      </div>

      {parseErrors.length > 0 && (
        <div className={styles.parseErrorsSection}>
          <p className={`body-md-semibold ${styles.parseErrorWarning}`}>
            {t('bulkUploads.parseErrorWarning', { count: parseErrors.length })}
          </p>
          <div className={styles.parseErrorsList}>
            {parseErrors.map((err) => (
              <div key={err.rowNumber} className={`body-sm-regular ${styles.parseErrorItem}`}>
                <span className="body-sm-semibold">{t('bulkUploads.rowNumber')} {err.rowNumber}:</span>{' '}
                {err.message}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={styles.confirmActions}>
        <Button variant="white" onClick={onCancel} disabled={isLoading}>
          {t('bulkUploads.cancel')}
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? t('bulkUploads.processing') : t('bulkUploads.confirm')}
        </Button>
      </div>
    </div>
  );
}
